import {
    Datagrid,
    List,
    Show,
    SimpleShowLayout,
    TextField,
    Pagination,
    ReferenceArrayField,
    ChipField,
} from "react-admin";
import { TextInput } from "react-admin";
import { ConfirmOnRecordButton, LongDateField } from "./customFields";
import { OrderedSingleFieldList } from "./orderedSingleFieldList";

const ddexIssueFilters = [<TextInput source="q" label="Search" alwaysOn />];

export const DDEXIssueList = () => (
    <List
        filters={ddexIssueFilters}
        perPage={50}
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100, 200, 1000]} />}
        sort={{ field: "created_at", order: "DESC" }}
    >
        <Datagrid rowClick="show">
            <TextField source="key" />
            <TextField source="nb_messages" label="Affected messages" />
            <LongDateField source="created_at" />
        </Datagrid>
    </List>
);

const ApplyButton = () => {
    return (
        <ConfirmOnRecordButton
            confirmTitle="Apply failed messages"
            confirmBody="Are you sure to re-run the failed messages?"
            url="/cms/ddex/issues/{id}/apply_messages"
            text="Apply failed messages"
            redirectTo="/background_processings"
        />
    );
};

export const DDEXIssueShow = () => (
    <Show>
        <SimpleShowLayout>
            <h2>DDEX Issue</h2>

            <TextField source="key" />
            <LongDateField source="created_at" />
            <TextField source="nb_messages" label="Affected messages" />
            <ReferenceArrayField
                label="Affected messages (last 50)"
                reference="ddex/messages"
                source="message_ids"
            >
                <OrderedSingleFieldList source="message_ids">
                    <ChipField source="id" size="small" />
                </OrderedSingleFieldList>
            </ReferenceArrayField>

            <TextField source="logs" component="pre" fontFamily={"monospace"} />
            <TextField source="id" />
            <ApplyButton />
        </SimpleShowLayout>
    </Show>
);
